<template lang="pug">
.flex.items-start.flex-wrap
	.block(class="lg:pl-8 p-0 w-full")
		.block(class="lg:py-4 p-4")
			//- .filter-info.text-light.flex.items-center.justify-between.mb-4
				.flex(class="lg:flex-row flex-col")
					p(style="padding-right:4px") Showing data from 
					span Jawa Barat, Kota Bandung
				.mobile-only
					button.btn-primary-o(
						type='button'
						v-on:click="filterShow = !filterShow"
					) Change Filter
			.flex.items-center.justify-between
				.field.mr-2.relative.field--search
					span Found {{ search_by_name_pln.length ? search_by_name_pln.length : 0 }} data
				//- .flex.flex-wrap.items-center
					span.mr-2.m-hide Show
					.field.relative
						select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
							option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
						.pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
							<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
					span.ml-2.m-hide entries
		.table-static.w-full
			table
				thead
					tr
						th(v-for="(th, index) in tableThead" :key="index")
							| {{ th.name }}
				tbody
					tr(v-if="load_data_status_search_by_name_pln === 'loading'")
						td.text-center(:colspan="tableThead.length")
							.flex.flex-wrap.items-center.justify-center
								Spinner(show="true" size="48")

					//- template(v-else-if="search_by_name_pln.data && search_by_name_pln.data.length > 0")
					template(v-else-if="search_by_name_pln && search_by_name_pln.length > 0")
						tr(v-for="(data, index) in search_by_name_pln" :key="index")
							td {{ data.Name ? data.Consumer_Name : '-' }}
							td {{ data.Address ? data.Address : '-' }}
							td {{ data.Created_At ? data.Created_At : '-' }}
							td {{ data.Last_Update ? data.Last_Update : '-' }}
							td 
								button.btn-primary(
									@click="viewData(data)"
								) View

					tr(v-else)
						td.text-center(:colspan="tableThead.length") No Data Available

			.mt-5
			vue-ads-pagination(
				:total-items="total_data"
				:items-per-page="items_per_page"
				:page="page"
				:max-visible-pages="5"
			)
				template(slot="buttons" slot-scope="props")
					vue-ads-page-button(
						v-for="(button, key) in props.buttons"
						:key="key"
						v-bind="button"
						:class="{'bg-yellow-dark': button.active}"
						@page-change="page = button.page"
						@range-change="start = button.start; end = button.end"
					)

	section(v-if="selectedData").section-popup.section-popup--show.fixed.w-full-h.full.inset-0.flex.items-start.justify-center
		.section-popup__container
			.box
				.box__header.no-border
					header.flex.items-center.justify-between
						.header-meta
							div.flex.items-center
								span.text-light.name-index {{ selectedData.Consumer_Name }}
						.header-cta
							button.btn-icon.btn-icon-40(v-on:click="viewData()")
								.icon-btn
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
				.box__body.p-4
					.mb-12.grid.gap-x-12.gap-y-4.grid-cols-2
						.block.mb-4
							span.block.mb-2.text-light Name
							h3.font-normal {{ selectedData.Name?selectedData.Name:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Consumer Name
							h3.font-normal {{ selectedData.Consumer_Name?selectedData.Consumer_Name:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Customer ID
							h3.font-normal {{ selectedData.Idpel?selectedData.Idpel:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Address
							h3.font-normal {{ selectedData.Address?selectedData.Address:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Energy Type
							h3.font-normal {{ selectedData.Energy_Type?selectedData.Energy_Type:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Kwh
							h3.font-normal {{ selectedData.Kwh?selectedData.Kwh:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Meter Type
							h3.font-normal {{ selectedData.Meter_Type?selectedData.Meter_Type:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Meter No
							h3.font-normal {{ selectedData.Meter_No?selectedData.Meter_No:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Unit Upi Name
							h3.font-normal {{ selectedData.Nama_Unit_Upi?selectedData.Nama_Unit_Upi:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Unit Upi
							h3.font-normal {{ selectedData.Unit_Upi?selectedData.Unit_Upi:'-' }}	
						.block.mb-4
							span.block.mb-2.text-light Unit Ap Name
							h3.font-normal {{ selectedData.Nama_Unit_Ap?selectedData.Nama_Unit_Ap:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Unit Ap
							h3.font-normal {{ selectedData.Unit_Ap?selectedData.Unit_Ap:'-' }}
						.block.mb-4
							span.block.mb-2.text-light Unit Up Name
							h3.font-normal {{ selectedData.Nama_Unit_Up?selectedData.Nama_Unit_Up:'-' }}	
						.block.mb-4
							span.block.mb-2.text-light Unit Up
							h3.font-normal {{ selectedData.Unit_Up?selectedData.Unit_Up:'-' }}	
						.block.mb-4
							span.block.mb-2.text-light Created At
							h3.font-normal {{ selectedData.Created_At?selectedData.Created_At:'-' }}	
						.block.mb-4
							span.block.mb-2.text-light Last Update
							h3.font-normal {{ selectedData.Last_Update?selectedData.Last_Update:'-' }}	
</template>

<script>
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
// import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
// import moment from 'moment';

export default {
	name: 'SourcePln',
	components: {
		Spinner,
		VueAdsPagination,
		VueAdsPageButton,
		// DateRangePicker,
	},
	data(){
		return {
			filterShow: false,
			tableThead: [
				{
					name: 'Consumer Name',
					// number: true,
				},{
					name: 'Address',
				},{
					name: 'Created At',
				},{
					name: 'Last Update',
				},{
					name: '',
				},
			],
			keyword: '',
			data_result: [],

			// pagination
			total_data: 0,
			items_per_page: 10,

			size: [10, 25, 50, 100],

			page: 0,
			start: 0,
			end: 0,

			timeout: null,
			selectedData: null,

			// dateRange: {
			//	 startDate: '',
			//	 endDate: '',
			// },
			// default_ranges: {
			//	 'Today': [moment().toDate(), moment().toDate()],
			//	 'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
			//	 // 'This month': [moment().startOf('month'), moment().endOf('month')],
			//	 // 'This year': [moment().startOf('year'), moment().endOf('year')],
			//	 'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
			//	 'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
			//	 // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
			// },
		}
	},
	computed: {
		...mapState([
			'load_data_status_search_by_name_pln',
			'search_by_name_pln',
		]),
		route_name() {
			return this.$route.name;
		},
		key() {
			return this.$route.params.key;
		},
		isKey() {
			// return this.key!==undefined ? true : false;
			return this.key ? true : false;
		},
	},
	watch: {
		key() {
			this.$store.commit('setSearchByNamePln', []);
		},
		isKey() {},
		breadcrumb() {},

		search_by_name_pln(newData) {
			if (newData.length > 0) {
				this.total_data = parseInt(newData.length);
				// this.page = (parseInt(newData.current_page) - 1);
			}
		},
		total_data() {
			// this.pagination();
		},
		items_per_page() {
			// this.getData();
			// this.pagination();
		},
		page() {
			// this.getData();
		},
	},
	methods: {
		encrypt(key, type) {

			// remove space in prefix
			if (key.substr(0, 1) === ' ')
				key = key.substr(1, (key.length - 1));

			if (type === 'msisdn') {

				let prefix_key = key.substr(0, 1);

				if (prefix_key === 0 || prefix_key === '0') {
					key = '62' + key.substr(1, (key.length - 1));
				} else if (key.substr(0, 4) === '+620') {
					key = '62' + key.substr(4, (key.length - 4));
				} else if (prefix_key === '+') {
					key = key.substr(1, (key.length - 1));
				}
			}

			return encrypt(key + '&&' + type);
		},
		
		async getData() {
			if (this.route_name === 'PageName' ) {
				// const default_date = this.$store.getters.getDefaultDate();

				// this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
				// this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

				// this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
				// this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

				if (this.isKey) {
					
					let decrypt_data = decrypt(this.key);
					decrypt_data = decrypt_data.split('&&');
					
					var key = decrypt_data[0];
					// var type = decrypt_data[1];
					
					// gender='', birth_date='', age_min='', age_max=''
					
					await this.$store.dispatch('getSearchByNamePln',[key]);
				
					this.pagination();
					
				} else {
					this.$store.commit('setSearchByNamePln', []);
				}				
			}
		},
		reset() {

			this.$swal.fire({
				icon: 'warning',
				title: 'Are you sure you want to reset?',
				// text: 'Role : ' + name,
				confirmButtonText: 'Yes!',
				confirmButtonColor: '#DD6B55',
				showCancelButton: true,
				allowOutsideClick: false,
			})
			.then((result) => {
				// console.log('on result');
				if (result.isConfirmed) {
					this.getData();
				}
			});

		},
		// pagination
		pageChange(page) {
			this.page = page;
		},
		rangeChange(start, end) {
			this.start = start;
			this.end = end;
		},
		sizeChange() {
			this.page = 0;
		},
		pagination() {
			// update fontawesome to iconfont
			var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

			if (paginationButtonPreview[0]) {
				var classListPrev = paginationButtonPreview[0].classList;

				if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
					paginationButtonPreview[0].classList.add('iconfont');
					paginationButtonPreview[0].classList.add('iconleft');
					paginationButtonPreview[0].style.fontSize = '12px';
				}
			}

			var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

			if (paginationButtonNext[0]) {
				var classListNext = paginationButtonNext[0].classList;

				if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
					paginationButtonNext[0].classList.add('iconfont');
					paginationButtonNext[0].classList.add('iconright');
					paginationButtonNext[0].style.fontSize = '12px';
				}
			}
		},
		
		showLoading(show=true) {
			if (show) {
				this.$swal.fire({
					title: '',
					html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
					showConfirmButton: false,
					allowOutsideClick: false
				});

			} else {
				this.$swal.close();
			}
		},
		viewData(data=null) {
			this.selectedData= data
		},
	},
	mounted() {
		// console.log('on Pln')
		EventEmit.$on('openSearchByNamePln', () => {
			// this.getData();
			if (this.page !== 0) {
				this.page = 0;
			} else {
				this.getData();
			}
		});
	},
}
</script>